import "~/scss/page-templates/home.scss";
// import "~/scss/components/moviesList.scss";

import EmblaCarousel from "embla-carousel";

import { Parallax } from "~/js/components/parallax/parallax";

console.log('home.ts');


const moviesListEl:HTMLElement|null = document.querySelector(".movies-list");
let moviesListEmblaNode:HTMLElement|null = null;
if( moviesListEl !== null ) {
  moviesListEmblaNode = moviesListEl.querySelector(".embla");
}

let moviesListEmblaPrevButton:HTMLElement|null = null;
let moviesListEmblaNextButton:HTMLElement|null = null;
let moviesListEmblaContainer:HTMLElement|null = null;


if( moviesListEl !== null && moviesListEmblaNode !== null ) {
  const moviesListEmblaViewport:HTMLElement|null = moviesListEmblaNode.querySelector(".embla__viewport");

  if( moviesListEmblaViewport !== null ) {
    moviesListEmblaContainer = moviesListEl.querySelector(".embla__container");
    moviesListEmblaPrevButton = moviesListEl.querySelector(".embla__prev");
    moviesListEmblaNextButton = moviesListEl.querySelector(".embla__next");

    const options = { 
      loop: true, 
      active: true, 
      // breakpoints: {
      //   '(min-width: 768px)' : { active: false }
      // }
    };
    const moviesListEmblaApi = EmblaCarousel(moviesListEmblaViewport, options);

    console.log(moviesListEmblaApi);

    if( moviesListEmblaPrevButton ) {
      moviesListEmblaPrevButton.addEventListener("click", moviesListEmblaApi.scrollPrev, false);

      console.log("initialize prev button");
    }

    if( moviesListEmblaNextButton ) {
      moviesListEmblaNextButton.addEventListener("click", moviesListEmblaApi.scrollNext, false);
    }

    toggleCarouselButtons();
  }
  
}

function toggleCarouselButtons() {
  console.log("toggleCarouselButtons()");

  if( moviesListEl ) {
    let emblaSlides = moviesListEl.querySelectorAll(".embla__slide");
      
    let visibleSlidesCount = 3;

    if( window.innerWidth >= 768 ) {
      visibleSlidesCount = 4;

      // moviesListEmblaContainer?.classList.add("no-scrolling");
      
    } else {
      // moviesListEmblaContainer?.classList.remove("no-scrolling");
    }

    console.log("emblaSlides.length:", emblaSlides.length);

    if( emblaSlides.length > visibleSlidesCount ) {
      moviesListEmblaContainer?.classList.remove("no-scrolling");
    } else {
      moviesListEmblaContainer?.classList.add("no-scrolling");
    }

    if( emblaSlides.length > visibleSlidesCount ) {
      if( moviesListEmblaPrevButton ) {
        moviesListEmblaPrevButton.classList.remove("hidden");
      }

      if( moviesListEmblaNextButton ) {
        moviesListEmblaNextButton.classList.remove("hidden");
      }
    } else {
      if( moviesListEmblaPrevButton ) {
        moviesListEmblaPrevButton.classList.add("hidden");
      }

      if( moviesListEmblaNextButton ) {
        moviesListEmblaNextButton.classList.add("hidden");
      }
    }
  }
}


const heroCarouselEl:HTMLElement|null = document.querySelector(".hero__carousel");
let heroCarouselEmblaEl:HTMLElement|null = null;
if( heroCarouselEl !== null ) {
  heroCarouselEmblaEl = heroCarouselEl.querySelector(".embla");
}

let heroCarouselEmblaContainer:HTMLElement|null = null;
let heroCarouselEmblaDotEls = null;

let heroCarouselEmblaApi:any = null;
let heroCarouselTimeoutId:any = null;


if( heroCarouselEl !== null && heroCarouselEmblaEl !== null ) {
  const heroCarouselEmblaViewport:HTMLElement|null = heroCarouselEmblaEl.querySelector(".embla__viewport");

  if( heroCarouselEmblaViewport !== null ) {
    const options = {
      loop: true,
      active: true
    };

    heroCarouselEmblaApi = EmblaCarousel(heroCarouselEmblaViewport, options);

    heroCarouselEmblaDotEls = heroCarouselEmblaViewport.querySelectorAll(".embla__dot");
    heroCarouselEmblaDotEls.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        heroCarouselEmblaApi.scrollTo(index, false);
      })
    });

    toggleHeroCarouselDotButton(heroCarouselEmblaApi, heroCarouselEmblaDotEls);

    heroCarouselEmblaApi.on("select", (emblaApi) => {
      toggleHeroCarouselDotButton(heroCarouselEmblaApi, heroCarouselEmblaDotEls);

      startHeroCarouselAutoSlide();
    })
    
    startHeroCarouselAutoSlide();
  }
}

function toggleHeroCarouselDotButton(emblaApi, dotBtns) {
  if( !dotBtns && dotBtns.length === 1 ) {
    return;
  }

  const previous = emblaApi.previousScrollSnap();
  const selected = emblaApi.selectedScrollSnap();

  dotBtns[previous].classList.remove("embla__dot--selected");
  dotBtns[selected].classList.add("embla__dot--selected");
}

function startHeroCarouselAutoSlide() {
  if( heroCarouselTimeoutId !== null ) {
    clearTimeout(heroCarouselTimeoutId);
  }

  if( heroCarouselEmblaApi ) {
    heroCarouselTimeoutId = setTimeout(() => {
      heroCarouselEmblaApi.scrollNext();
    }, 3500);
  }
}




window.addEventListener("resize", () => {
  toggleCarouselButtons();
})


// let parallaxEls = document.querySelectorAll(".movie-slide__parallax-container");
// let parallax = [];
// for( let i=0; i<parallaxEls.length; i++ ) {
//   let parallax = new Parallax(parallaxEls[i]);
// }
